<template>
  <div class="activity-page">
    <div class="header">
      <div class="logo">
        <img src="../assets/img/pic/logo03.jpg" alt="LiveABC Logo">
      </div>
      <nav class="navigation">
        <a href="#home">首頁</a>
        <a href="#intro">活動說明</a>
        <a href="#award">活動獎項</a>
      </nav>
    </div>

    <div id="home" class="main-banner">
      <div class="banner-image-placeholder">
      </div>
    </div>

    <div class="activity-intro">
      <div class="intro-content">
        <h2>活動簡介</h2>
        <p>
          LiveABC 在數位教學平台領域長達 10 餘年的鑽研，吸取了全國超過 300 間學校及海外多國的使用心得與意見進行不斷的更新，結合最新雲端服務，進而淬鍊出最新一代外語數位學習平台：『<a href="javascript:void(0)" @click="goHome()">LiveABC 英語日語AI互動學習資料庫</a>』。
        </p>
        <p>
          包含【雜誌主題館】及【遊台灣學英文】和【AI英日語小助教】三大部分。
        </p>
        <ul style="list-style: none; padding: 10px 0px;">
          <li class="pb-2">一、【雜誌主題館】： 提供LiveABC出版的雜誌別及CNN官方獨家授權影片，從全球新聞、亞洲世界新聞、商業新聞中心、娛樂線上等10大節目中。分類成十六大主題。</li>
          <li class="py-2">二、【遊台灣學英文】： 以台灣縣市作為分類，使用者可至各縣市分類中看到特色景點相關的英文學習內容。</li>
          <li class="pt-2">三、【AI英日語小助教】： AI 寫作評估：即時批改,提供單字與句構建議，提升寫作表現。AI 互動學習：語音識別 + AI 即時回饋,模擬真實對話情境。情境式口說訓練：多元生活場景，強化實際應用能力。多元測驗支援：涵蓋學測 & GEPT 口說與寫作練習，全方位提升應試能力。</li>
        </ul>
        <p>
          這絕對是各大圖書館讀者及各級學校相關語言學習單位之師生最佳外語自學閱讀期刊資料庫。
        </p>
        <p>
          歡迎大家踴躍參加本次有獎徵答活動，體驗學習樂趣！
        </p>
        <p>
          LiveABC 英語日語AI互動學習資料庫網址： <a href="https://library.liveabc.com/">https://library.liveabc.com/</a>
        </p>
      </div>
    </div>
    <div id="intro" class="activity-description">
      <div class="description-content">
        <h2>活動說明</h2>
        <div class="description-item">
          <h3>【活動時間】</h3>
          <p>即日起 ~ 2025年12月25日</p>
        </div>
        <div class="description-item">
          <h3>【活動對象】</h3>
          <p>臺灣學術電子資源永續發展計畫 73 所技專校院教職員工生。</p>
        </div>
        <div class="description-item">
          <h3>【活動辦法】</h3>
          <p>參加有獎徵答活動並填寫個人資料。凡個人資料完整、答題全正確的參加者即可參與抽獎。</p>
        </div>
        <div class="description-item">
          <h3>【注意事項】</h3>
          <ol>
            <li>請務必填寫所有欄位，若資料缺漏將取消參加資格。</li>
            <li>參加者必須填寫有效的電子信箱。每個電子信箱僅限參加活動一次。</li>
            <li>使用程式或機器人大量填答題目者，視同違反活動公平原則，將取消參加資格。</li>
            <li>獎項於得獎名單公佈後，主辦單位會以 e-mail 通知中獎者，通知後一週內如無回覆或未能領獎者視同放棄；獎項將以郵寄方式發送。必要時主辦單位得請得獎者出示學生證或教職員服務證明以確認身份。</li>
            <li>得獎者若同一人重複中獎，將取最高之獎項送出。獎品將依所得稅法相關規定辦理，逾期為領取者視同放棄。</li>
            <li>主辦單位保留修改活動辦法之權利。</li>
            <li>參加活動者視同認可並接受本辦法各項規定。</li>
          </ol>
        </div>
        <div class="join-now-section">
          <button class="join-now-btn" @click="goQuestionnaire">立即參加</button>
          <p class="robot-warning">(請勿使用機器人填答)</p>
        </div>
      </div>
    </div>
    <div id="award" class="activity-prizes">
      <div class="prizes-content">
        <h2>活動獎項</h2>
        <h3 class="prizes-subtitle">豐富大獎等你來拿！
        </h3>
        <h3 class="prizes-subtitle">
          得獎名單將於2025年12月30日公布 <a href="javascript:void(0)" @click="goReward">"得獎名單連結"</a>
        </h3>
        <div class="prizes-table">
          <div class="table-header">
            <div class="table-cell">獎品照片</div>
            <div class="table-cell">獎項</div>
            <div class="table-cell">獎品內容</div>
            <div class="table-cell">名額</div>
          </div>
          <div class="table-row">
            <div class="table-cell prize-image-placeholder">
              <img style="width:100%" src="../assets/img/pic/REWARD01.png" alt="LiveABC Logo">
            </div>
            <div class="table-cell prize-name">頭獎</div>
            <div class="table-cell">iPad 11 A16/11吋/WiFi/128G</div>
            <div class="table-cell">共 1 名</div>
          </div>
          <div class="table-row">
            <div class="table-cell prize-image-placeholder">
              <img  style="width:100%"  src="../assets/img/pic/REWARD02.png" alt="LiveABC Logo">
            </div>
            <div class="table-cell prize-name">二獎</div>
            <div class="table-cell">LiveABC 智慧藍芽點讀筆</div>
            <div class="table-cell">共 2 名</div>
          </div>
          <div class="table-row">
            <div class="table-cell prize-image-placeholder">
              <img style="width:100%" src="../assets/img/pic/REWARD03.png" alt="LiveABC Logo">
            </div>
            <div class="table-cell prize-name">三獎</div>
            <div class="table-cell">AWEI-Y526 可攜式戶外迷你藍芽音箱</div>
            <div class="table-cell">共 3 名</div>
          </div>
          <div class="table-row">
            <div class="table-cell prize-image-placeholder">
              <img style="width:100%" src="../assets/img/pic/REWARD04.png" alt="LiveABC Logo">
            </div>
            <div class="table-cell prize-name">四獎</div>
            <div class="table-cell">7-11 商品卡 200元</div>
            <div class="table-cell">共 30 名</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Activity',
  components: {
  },
  data () {
    return {
      searchData: ''
    }
  },
  watch: {

  },
  methods: {
    goHome () {
      const route = this.$router.resolve({ name: 'Home' })
      window.open(route.href, '_blank')
    },
    goQuestionnaire () {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSeVraPJstr019LGCu2dAC5CCMS_J9FpLbiCv8_es848NQsZqA/viewform', '_blank')
    },
    goReward () {
      window.open('https://docs.google.com/spreadsheets/d/1UgsIxhjzJTW5X1o1s2Fw6rbvQvniCuhs/edit?usp=sharing&ouid=103289672619860490043&rtpof=true&sd=true', '_blank')
    }
  },
  mounted () {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault()
        const target = document.querySelector(this.getAttribute('href'))
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          })
        }
      })
    })
  }
}
</script>

<style scoped>
.activity-page {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
  background-color: #e9f5ff;
}

html {
  scroll-behavior: smooth;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.logo img {
  height: 40px;
}

.navigation a {
  margin-left: 1.5rem;
  text-decoration: none;
  color: #555;
  font-weight: bold;
}

.navigation a:hover {
  color: #007bff;
}

/* Main Banner */
.main-banner {
  background-color: #004a99;
  background-image: url("../assets/img/pic/home_hero_M.png");
  background-size: cover;
  min-height: 600px;
}

.banner-content h1 {
  font-size: 1.5rem;
  font-weight: normal;
}

.banner-content h2 {
  font-size: 4rem;
  font-weight: bold;
  margin: 1rem 0;
}

.date-range {
  border: 2px solid #fff;
  padding: 0.5rem 2rem;
  display: inline-block;
  margin: 1rem 0;
}

.date-range p {
  margin: 0;
  font-size: 1.2rem;
}

.sponsor p {
  font-size: 0.9rem;
  margin-top: 2rem;
}
.banner-image-placeholder {
  width: 300px;
  height: 300px;
  background-color: #ccc;
  position: absolute;
  bottom: -50px;
  left: 10%;
  border-radius: 10px;
  display:none;
}
/* Sections */
.activity-intro,
.activity-description,
.activity-prizes {
  text-align: left;
  padding: 2rem;
  max-width: 900px;
  margin: 2rem auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow:  0px 4px 6px #a1a1a1a1;
}

.intro-content h2,
.description-content h2,
.prizes-content h2 {
  text-align: center;
  font-size: 2rem;
  color: #004a99;
  margin-bottom: 2rem;
}

.intro-content p,
.intro-content ul,
.description-item p,
.description-item ol {
  line-height: 1.8;
  font-size: 1.1rem;
}

.intro-content ul {
  list-style-type: disc;
  padding-left: 2rem;
}

.description-item {
  margin-bottom: 1.5rem;
}

.description-item h3 {
  color: #004a99;
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
}

/* Prizes Table */
.prizes-subtitle {
  text-align: center;
  font-size: 1rem;
  color: #333;
  margin-bottom: 1.5rem;
}

.prizes-table {
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #ddd;
  font-size: 1.25rem;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
}

.table-header {
  display: table-header-group;
  background-color: #004a99;
  color: #fff;
  font-weight: bold;
}

.table-row {
  display: table-row;
}

.table-row:nth-of-type(even) {
  background-color: #f9f9f9;
}

.table-row:hover {
  background-color: #f1f1f1;
}

.table-cell {
  display: table-cell;
  padding: 1rem;
  border-bottom: 1px solid #ddd;
  text-align: center;
  vertical-align: middle;
}

.prize-name {
  color: #ff8c00;
  font-weight: bold;
}

.prize-image-placeholder {
  padding: 0;
  width: 125px;
  height: 125px;
  background-color: #eee;
  display: inline-block;
}
.join-now-section {
  text-align: center;
  margin-top: 2rem;
}

.join-now-btn {
  background-color: #ff9800;
  color: #fff;
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.join-now-btn:hover {
  background-color: #e68900;
}

.robot-warning {
  margin-top: 0.5rem;
  color: #777;
  font-size: 0.9rem;
}
@media screen and (max-width: 480px){
  .logo {
    display: none;
  }
  .main-banner {
    background-color: #004a99;
    color: #fff;
    background-image: url("../assets/img/pic/home_hero_S.png");
    background-size: cover;
    min-height: 400px;
  }
}
</style>
